// Иконки сервисов.
//
// Файлы распакованы из .icns (macOS) в WebP 192px и лежат в
// public/icons/services. public отдаётся статикой напрямую, поэтому они НЕ
// попадают в JS-бандл: двадцать иконок весят 82 КБ и грузятся по мере
// надобности, а не вместе с приложением.
//
// 192 пикселя выбраны по самому крупному месту показа: в листе операции
// плитка 48 пикселей, на экране с тройной плотностью это 144. Меньше — мылит.
//
// У всех иконок СВОЯ скруглённая форма и прозрачные углы, поэтому подкладывать
// под них плитку с рамкой нельзя: рамка обвела бы квадрат вокруг скруглённого
// силуэта.

export const SERVICE_ICONS = [
  "airbnb", "amazon", "apple-music", "booking", "chatgpt", "claude", "discord",
  "figma", "gemini", "mcdonalds", "netflix", "notion", "seven-eleven", "spotify",
  "starbucks", "twitch", "uber", "ubereats", "youtube", "zoom",
];

export const iconUrl = (slug) => `/icons/services/${slug}.webp`;

// Названия приходят от эмитента как есть: «Beam*bolt TH», «4367BOOTS-PROTO DE
// PHU TH» — с кодом города, страной, префиксом агрегатора. Поэтому сверяемся по
// вхождению, а не по равенству.
//
// Порядок значим: Uber Eats обязан проверяться РАНЬШЕ Uber, иначе доставка
// получит иконку такси.
const RULES = [
  [/uber\s*eats|ubereats/i, "ubereats"],
  [/\buber\b/i, "uber"],
  [/netflix/i, "netflix"],
  [/spotify/i, "spotify"],
  [/youtube|google\s*\*?\s*yout/i, "youtube"],
  [/apple\s*music|itunes/i, "apple-music"],
  [/openai|chatgpt/i, "chatgpt"],
  [/claude|anthropic/i, "claude"],
  [/gemini/i, "gemini"],
  [/amazon|\bamzn\b|\baws\b/i, "amazon"],
  [/booking/i, "booking"],
  [/airbnb/i, "airbnb"],
  [/discord/i, "discord"],
  [/twitch/i, "twitch"],
  [/figma/i, "figma"],
  [/notion/i, "notion"],
  [/zoom/i, "zoom"],
  [/starbucks/i, "starbucks"],
  [/mcdonald/i, "mcdonalds"],
  [/7\s*-?\s*eleven|seven\s*eleven/i, "seven-eleven"],
];

export const matchService = (name) => {
  const value = String(name || "");
  if (!value) return null;
  for (const [pattern, slug] of RULES) {
    if (pattern.test(value)) return slug;
  }
  return null;
};
